import React from 'react';
import { Paper, Link, Box } from '@mui/material';
import { format, differenceInDays, formatDuration } from 'date-fns';
import { ru } from 'date-fns/locale';

import { routesMap } from 'src/routes';
import { Table } from 'src/components/common/Table';
import { Promotion } from 'src/types/api';

interface Props {
  promotions?: Promotion[] | null;
  totalCount?: number | null;
  refetch: () => any;
  isLoading: boolean;
  limit?: number;
  offset?: number;
  onChange?: (data: any) => any;
}

export const Promotions: React.FunctionComponent<Props> = ({
  promotions,
  totalCount,
  refetch,
  isLoading,
  limit,
  offset,
  onChange,
}) => {
  return (
    <div>
      <Paper>
        <Table
          title="Акции"
          headers={[
            {
              title: 'id',
              component: 'th',
              scope: 'row',
              align: 'right',
              extract: (item: Promotion) =>
                item.id && (
                  <Link
                    href={routesMap.promotion.getRoute(item.id)}
                    target="_blank"
                  >
                    {item.id}
                  </Link>
                ),
            },
            {
              title: 'Период проведения',
              align: 'right',
              extract: (item: Promotion) => {
                const daysLeft = item.finish
                  ? differenceInDays(new Date(item.finish), new Date())
                  : 0;
                return (
                  item.start &&
                  item.finish && (
                    <Box>
                      <Box>
                        {format(new Date(item.start), 'yyyy-MM-dd')} -{' '}
                        {format(new Date(item.finish), 'yyyy-MM-dd')}
                      </Box>
                      <Box fontSize="11px">
                        {formatDuration(
                          {
                            days: differenceInDays(
                              new Date(item.finish),
                              new Date(item.start),
                            ),
                          },
                          { locale: ru },
                        )}
                        {Boolean(daysLeft > 0) ? (
                          <>
                            {', еще '}
                            {formatDuration(
                              {
                                days: daysLeft,
                              },
                              { locale: ru },
                            )}
                          </>
                        ) : (
                          ', завершена'
                        )}
                      </Box>
                    </Box>
                  )
                );
              },
            },
            {
              title: 'Оригинальное название',
              extract: (item: Promotion) => item.vendorName,
            },
            {
              title: 'Публичное название',
              extract: (item: Promotion) => item.title,
            },
            {
              title: 'Баннер',
              extract: (item: Promotion) =>
                item.banner && <img src={item.banner} height="48px" />,
            },
          ]}
          data={promotions}
          totalCount={totalCount}
          onFetch={refetch}
          onChange={onChange}
          loading={isLoading}
          withPagination
          limit={limit}
          offset={offset}
        />
      </Paper>
    </div>
  );
};
